import React from 'react'
import Chatbox from '../Component/Chatbox';
import Footer from '../Component/Footer';
import logo from '../Image/logo.png';
import mpcst from '../Image/newmpcst-logo.jpg';
import { useLanguage } from '../context/LanguageContext';
import { Typography } from '@mui/material';
import { useLocation } from "react-router-dom";
import Header from "../Component/header";
import DesktopFooter from "../Component/Desktopfooter";

const Chatbot = () => {
  const { t } = useLanguage();
  return (
    <>
      <div className='aboutSection'>
         <Header/>
        <Chatbox />

      </div>
       <DesktopFooter/>
      <Footer />
    </>
  )
}

export default Chatbot;
